import { AccountState } from './../models/account-state.model';
import { AccountSetUserRole } from './../actions/account.actions';
import { createReducer, on } from '@ngrx/store';

const initialState: AccountState = {
  userRoleId: 0,
};

export const accountReducer = createReducer<AccountState>(
  initialState,
  on(AccountSetUserRole, (state: any, { roleId }: any) => {
    return {
      ...state,
      userRoleId: roleId,
    };
  })
);
